import { DescriptionContentList } from './DescriptionContentList'
import { DescriptionContentToFrom } from './DescriptionContentToFrom'

export const AlertDescriptionContent = {
  List: DescriptionContentList,
  ToFrom: DescriptionContentToFrom,
}
